import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-health',
    templateUrl: './health.component.html',
    standalone: false
})
export class HealthComponent {

  statusMessage = '{"status": "OK"}';

}
